const fragment = `
  id
  type
  createdAt
  user {
    id
    name
    contact {
      id
    }
    company {
      name
    }
  }
`;

export const listToursQuery = `
  query ListTours(
    $filter: TourFilterInput
  ) {
    items: listTours(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getTourQuery = `
  query GetTour($id: Int!) {
    item: getTour(id: $id) {
      ${fragment}
    }
  }
`;

export const countActiveToursQuery = `
  query CountActiveTours($filter: TourFilterInput) {
    count: countActiveTours(filter: $filter)
  }
`;
